import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-light text-center py-3">
            <p className="mb-0">&copy; 2025 Amanda Calem. Todos los derechos reservados.</p>
        </footer>
    );
};

export default Footer;